import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  deviceSoftwareList,
  deviceSoftwareCreateReset,
  deviceSoftwareCreate,
  deviceSoftwareUpdate,
  deviceSoftwareDelete,
  deviceSoftwareSelect,
  deviceTypeList,
  getDeviceRepositoryAll,
  getMinimumVersions
} from '../../redux/actions'

import {
  getActiveLanguage
} from 'react-localize-redux'

import {
  preparePager,
  prepareSearch
} from '../../common/tabletools'

import NoData from '../../components/nodata'
import DeviceSoftwareReleases from '../../components/devicesoftwarereleases'

class DeviceSoftwareReleasesPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pager: {
        defaultColumns: ['deviceupdaterepositoryname', 'systemdevicetypename', 'version', 'minimumsystemversion', 'isfullsystemupdate'],
        manual: true,
        pageno: 1,
        pagesize: 5,
        order: {},
        search: [],
        global: false
      }
    }
    this.fetch = this.fetch.bind(this);
    this.search = this.search.bind(this);
  }

  componentWillMount() { 
    this.props.reset();
    this.props.getDeviceTypes();
    this.props.getDeviceRepositoryAll();
    this.props.getMinimumVersions();
    this.props.getDeviceSoftwares(this.state.pager);
  }

  fetch(table) {
    const { pager } = this.state
    if (!pager.global)
    this.props.getDeviceSoftwares(preparePager(table, pager))
    else {
      let search = pager.search
      let pagers = preparePager(table, pager)
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search]
      }
      else {
        pagers.search = search
      }
      this.props.getDeviceSoftwares(pagers)
    }
  }

  search(term) {
    const { softwares } = this.props;
    const { columns } = softwares;
    const { pager } = this.state;
    const _pager = prepareSearch(term, columns, pager)
    _pager.global = term === '' ? false : true
    this.setState({
      pager: _pager
    });

    this.props.getDeviceSoftwares(_pager);
  }

  render() {
    const {
      translate,
      languages,
      create,
      created,
      softwareId,
      software,
      softwares,
      getDeviceSoftware,
      update,
      del,
      reset,
      deviceTypes,
      allRepositories,
      minimumVersions
    } = this.props;
    
    const {
      pager
    } = this.state

    return (
      (softwares) ? (
        <DeviceSoftwareReleases
          translate={translate}
          languages={languages}
          create={create}
          created={created}
          softwareId={softwareId}
          software={software}
          softwares={softwares}
          pager={pager}
          update={update}
          fetch={this.fetch} 
          search={this.search}
          reset={reset}
          get={getDeviceSoftware}
          del={del}
          deviceTypes={deviceTypes}
          allRepositories={allRepositories}
          minimumVersions={minimumVersions}
        />
      ) : (
          <NoData translate={translate} />
        )
    )
  }
}

const mapStateToProps = (state) => ({
  languages: state.localeReducer.languages,
  softwareId: state.deviceSoftwareReducer.softwareId,
  software: state.deviceSoftwareReducer.software,
  softwares: state.deviceSoftwareReducer.softwares,
  created: state.deviceSoftwareReducer.created,
  updated: state.deviceSoftwareReducer.updated,
  deviceTypes: state.deviceReducer.deviceTypes,
  allRepositories: state.deviceRepositoryReducer.allRepositories,
  minimumVersions: state.deviceSoftwareReducer.minimumVersions,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  getDeviceSoftwares: (pager) => {
    dispatch(deviceSoftwareList(pager))
  },
  getDeviceTypes: () => {
    dispatch(deviceTypeList())
  },
  getDeviceRepositoryAll: () => {
    dispatch(getDeviceRepositoryAll())
  },
  getMinimumVersions: () => {
    dispatch(getMinimumVersions())
  },
  create: (software, pager) => {
    return dispatch(deviceSoftwareCreate(software, pager))
  },
  update: (software, pager) => {
    return dispatch(deviceSoftwareUpdate(software, pager))
  },
  getDeviceSoftware: (id) => {
    dispatch(deviceSoftwareSelect(id))
  },
  reset: () => {
    dispatch(deviceSoftwareCreateReset())
  },
  del: (id, pager) => {
   return dispatch(deviceSoftwareDelete(id, pager))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceSoftwareReleasesPage)
